export enum WebMessageType {
	Contact = "Contact",
	Wholesale = "Wholesale",
}
